/* eslint-disable react/jsx-no-leaked-render */
import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { bool, func, string } from 'prop-types'

import TabList from '@taglivros/oef_componentes/build/components/tabList'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import { useModalidade } from '../../../contexts/ModalidadeContext'
import { useGlobal } from '../../../contexts/GlobalContext'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { AVISO_PIX_MENSAL, METODO_PAGAMENTO_PIX, PLANO_ANUAL, PLANO_TRIMESTRAL } from '../../../constants'
import { formatValor } from '../../../utils/formatter/formatter'
import { isEmptyObject, objetoTemPropriedade } from '../../../utils/helpers/helpers'
import { ETAPA_PLANO } from '../constantsFluxosPagamento'
import { tiposDePlanos } from '../../../containers/Modalidade/Plano/constantsPlano'

const WrapperPagmentoComPix = styled.div`
  position: relative;

  & > p {
    ${StyleGuide.tipografia.textoGrande}
    padding-left: 25px;
    position: relative;

    &:before {
      align-items: center;
      border: 1px solid;
      border-radius: 100%;
      content: '!';
      display: flex;
      font-size: 11px;
      height: 15px;
      justify-content: center;
      left: 0;
      position: absolute;
      top: 3px;
      width: 15px;
    }
  }
`

const ValorKitPix = styled.div`
  h4 {
    ${StyleGuide.boldFonte}
    color: ${StyleGuide.cores.cinza600};
    font-size: 24px;
    line-height: 1.25;
    margin-top: 20px;

    small {
      ${StyleGuide.tipografia.textoPequeno}
      color: ${StyleGuide.cores.cinza400};
    }
  }
`

// eslint-disable-next-line max-statements
const PagamentoComPix = ( { pixPlanoAnual, setPagamentoSelecionado, modalidadeSelecaoPlano } ) => {
  const { fetchPlanos, listaPlanosPorModalidade } = useModalidade()
  const { modalidadeURL, setValidCaptcha } = useGlobal()
  const { dadosEtapas, temaFluxo, calculaDescontoPix } = useFluxosPagamento()
  const [ modalidadeParaPlanos, setModalidadeParaPlanos ] = useState( null )
  const [ planosPix, setPlanosPix ] = useState( [] )
  const [ visualizacaoPlanosPix, setVisualizacaoPlanosPix ] = useState( [] )
  const [ planoSelecionadoPix, setPlanoSelecionadoPix ] = useState()
  const [ planoMudou, setPlanoMudou ] = useState( false )
  const hasDadosPlanos = !isEmptyObject( dadosEtapas ) && objetoTemPropriedade(
    dadosEtapas,
    ETAPA_PLANO
  ) && !isEmptyObject( dadosEtapas[ ETAPA_PLANO ] )
  const isPlanoAnual = hasDadosPlanos && dadosEtapas[ ETAPA_PLANO ].tipo === PLANO_ANUAL.visualizacao
  const isPlanoTrimestral = hasDadosPlanos && dadosEtapas[ ETAPA_PLANO ].tipo === PLANO_TRIMESTRAL.visualizacao
  const podeSelecionarPlanoPix = !pixPlanoAnual && !isPlanoAnual && !isPlanoTrimestral

  useEffect(
    () => {
      setModalidadeParaPlanos( modalidadeSelecaoPlano || modalidadeURL )
    },
    [ modalidadeSelecaoPlano, modalidadeURL ]
  )

  useEffect(
    () => {
      if ( modalidadeParaPlanos ) {
        fetchPlanos( modalidadeParaPlanos )
      }
    },
    [ modalidadeParaPlanos ]
  )

  useEffect(
    () => {
      if ( !isEmptyObject( listaPlanosPorModalidade ) ) {
        const filtrarPlanosPix = listaPlanosPorModalidade[ tiposDePlanos.NAO_PRESENTE ]
          .filter( plano => plano.metodosPagamento.includes( METODO_PAGAMENTO_PIX.visualizacao ) )
          .sort( ( planA, planB ) => planA.tipo < planB.tipo ? -1 : 1 )
        const listarPlanosPix = filtrarPlanosPix.map( plano => {
          return ( {
            'codigo': plano.id,
            'valor': calculaDescontoPix( plano.valorTotal ),
            'visualizacao': plano.tipo
          } )
        } )
        setVisualizacaoPlanosPix( listarPlanosPix )
        setPlanosPix( filtrarPlanosPix )
      }
    },
    [ listaPlanosPorModalidade ]
  )

  useEffect(
    () => {
      if ( visualizacaoPlanosPix && visualizacaoPlanosPix.length ) {
        if ( pixPlanoAnual || isPlanoAnual ) {
          const planoAnual = visualizacaoPlanosPix.find( plano => plano.visualizacao === PLANO_ANUAL.visualizacao )
          setPlanoSelecionadoPix( planoAnual.codigo )
          setPagamentoSelecionado( {
            'metodoPagamento': METODO_PAGAMENTO_PIX.slug,
            'plano': {
              'id': planoAnual.codigo,
              'tipo': planoAnual.visualizacao,
              'valor': planoAnual.valor
            } } )
        } else if ( pixPlanoAnual || isPlanoTrimestral ) {
          const planoTrimestral = visualizacaoPlanosPix.find( plano => plano.visualizacao === PLANO_TRIMESTRAL.visualizacao )
          setPlanoSelecionadoPix( planoTrimestral.codigo )
          setPagamentoSelecionado( {
            'metodoPagamento': METODO_PAGAMENTO_PIX.slug,
            'plano': {
              'id': planoTrimestral.codigo,
              'tipo': planoTrimestral.visualizacao,
              'valor': planoTrimestral.valor
            } } )
        } else if ( !pixPlanoAnual && !isPlanoAnual ) {
          setPlanoSelecionadoPix( visualizacaoPlanosPix[ 0 ].codigo )
          setPagamentoSelecionado( {
            'metodoPagamento': METODO_PAGAMENTO_PIX.slug,
            'plano': {
              'id': visualizacaoPlanosPix[ 0 ].codigo,
              'tipo': visualizacaoPlanosPix[ 0 ].visualizacao,
              'valor': visualizacaoPlanosPix[ 0 ].valor
            }
          } )
        }
      }
    },
    [ pixPlanoAnual, visualizacaoPlanosPix ]
  )

  useEffect(
    () => {
      if ( planoMudou && visualizacaoPlanosPix && visualizacaoPlanosPix.length ) {
        const planoSelecionado = visualizacaoPlanosPix.find( plano => plano.codigo === planoSelecionadoPix )
        if ( planoSelecionado ) {
          setPagamentoSelecionado( {
            'metodoPagamento': METODO_PAGAMENTO_PIX.slug,
            'plano': {
              'id': planoSelecionado.codigo,
              'tipo': planoSelecionado.visualizacao,
              'valor': planoSelecionado.valor
            }
          } )
        }
      }
    },
    [ planoMudou, planoSelecionadoPix, visualizacaoPlanosPix ]
  )

  useEffect( () => {
    setValidCaptcha( true )
  }, [] )

  return (
    <WrapperPagmentoComPix>
      { planosPix && visualizacaoPlanosPix && planoSelecionadoPix ?
        <Fragment>
          { podeSelecionarPlanoPix && (
            <Fragment>
              <p>{ AVISO_PIX_MENSAL }</p>

              <TabList
                ativo={ planoSelecionadoPix }
                itens={ visualizacaoPlanosPix }
                onClick={ codigo => {
                  setPlanoSelecionadoPix( codigo )
                  setPlanoMudou( codigo !== planoSelecionadoPix )
                } }
              />
            </Fragment>
          ) }

          { planosPix.map( plano => {
            if ( planoSelecionadoPix === plano.id ) {
              const hasDescontoPix = METODO_PAGAMENTO_PIX.desconto !== 0
              const valorTotalFormatado = formatValor( { 'valor': plano.valorTotal } )
              const valorTotalFormatadoComDesconto = hasDescontoPix ? formatValor( { 'valor': calculaDescontoPix( plano.valorTotal ) } ) : 0

              const discountDisplay = (
                <>
                  De {valorTotalFormatado} por {valorTotalFormatadoComDesconto}
                  <br />
                  <small>Desconto de {METODO_PAGAMENTO_PIX.desconto}% para PIX</small>
                </>
              )

              return (
                <ValorKitPix
                  key={ plano.id }
                >
                  { plano.valorTotal && plano.tipo &&
                    <h4>
                      { hasDescontoPix ? discountDisplay : `Total: ${valorTotalFormatado}` }
                    </h4>}
                </ValorKitPix>
              )
            }

            return null
          } ) }
        </Fragment> :
        <InlineLoader
          cor={ temaFluxo }
          isCenter
        />}
    </WrapperPagmentoComPix>
  )
}

PagamentoComPix.defaultProps = {
  'modalidadeSelecaoPlano': null
}

PagamentoComPix.propTypes = {
  'modalidadeSelecaoPlano': string,
  'pixPlanoAnual': bool.isRequired,
  'setPagamentoSelecionado': func.isRequired
}

export default PagamentoComPix
